import { Dto, DtoWithId } from "@mango/core";
import { Soort } from './soort';
import { Merk } from './merk';
import { SoortTemperatuur } from './soort-temp';
import { Rubriek } from "./rubriek";
import { Groep } from "../enums/groep";
import { Volgblad } from "./volgblad";
import { Voorblad } from "./voorblad";

@Dto({fullName: "CIJBorculo.Logic.InstrumentDefinitie"})
export class InstrumentDefinitie extends DtoWithId {
	groep: Groep;
	code: string;
	soortID: Soort;
	merkID: Merk;
	type: string;
	opmerking: string;
	rubriekID: Rubriek;
	voorbladID: Voorblad;
	volgbladID: Volgblad;
	rva: boolean;
	soortTempID: SoortTemperatuur;
	tijdStd: number;
	tijdCY: number;
	tijdRvA: number;
	bInstrument: boolean;
	bNieuw: boolean;
	bSelect: number;
	contract: string;
	bUitbesteed: boolean;
	bGeenService: boolean;
	prijsStd: number;
	prijsStdDatum: Date;
	prijsCY: number;
	prijsCydatum: Date;
	prijsRvA: number;
	prijsRvADatum: Date;
	prijsBrl100: number;
	prijsBrl100Datum: Date;
	prijsNen: number;
	prijsNendatum: Date;
	prijsKeuring: number;
	prijsKeuringDatum: Date;
	prijsCrossCheck: number;
	prijsCrossCheckdatum: Date;
	prijsScios: number;
	prijsSciosDatum: Date;
	prijsBRL6010: number;
	prijsBRL6010Datum: Date;
	prijsPool: number;
	prijsPoolDatum: Date;
	prijsKwestie: number;
	prijsKwestieDatum: Date;
	prijsPoolBuiten: number;
	prijsPoolBuitenDatum: Date;
	prijsKwestieBuiten: number;
	prijsKwestieBuitenDatum: Date;
}